import { SearchModelBase } from './SearchModelBase';
import * as XCol from '../../framework.core/XExportColumn';

export class CustomerShipmentListItem extends SearchModelBase {
    id: number = 0;    //only UI
    customer: string = '';
    custRefNo: string = '';
    mblId: number = 0;
    mblNo: string = '';
    hblId: number = 0;
    hblNo: string = '';
    containerNo: string = '';
    commodity: string = '';
    conType: string = '';
    pkgs: number|null = null;
    fromPkgs: number|null = null;
    toPkgs: number|null = null;
    cbm: number|null = null;
    fromCbm: number|null = null;
    toCbm: number|null = null;
    kgs: number|null = null;
    fromKgs: number|null = null;
    toKgs: number|null = null;
    lbs: number|null = null;
    fromLbs: number|null = null;
    toLbs: number|null = null;
    loadingPort: string = '';
    dischargePort: string = '';
    placeOfDelivery: string = '';
    steamShipName: string = '';
    vessel: string = '';
    voyage: string = '';

    etd: string | null = null;
    fromEtd: string | null = null;
    toEtd: string | null = null;

    eta: string | null = null;
    fromEta: string | null = null;
    toEta: string | null = null;

    feta: string | null = null;
    fromFeta: string | null = null;
    toFeta: string | null = null;

    //Container Dispatched
    ord: string | null = null;
    fromOrd: string | null = null;
    toOrd: string | null = null;

    //Gate In
    inGateDate: string | null = null;
    fromInGateDate: string | null = null;
    toInGateDate: string | null = null;

    //Vessel Loaded
    loadedDate: string | null = null;
    fromLoadedDate: string | null = null;
    toLoadedDate: string | null = null;

    //Vessel Departure
    vesselDepartureDate: string | null = null;
    fromVesselDepartureDate: string | null = null;
    toVesselDepartureDate: string | null = null;

    //Vessel Arrival
    vesselArrivalDate: string | null = null;
    fromVesselArrivalDate: string | null = null;
    toVesselArrivalDate: string | null = null;

    //Vessel Unloaded
    unloadedDate: string | null = null;
    fromUnloadedDate: string | null = null;
    toUnloadedDate: string | null = null;

    //Carrier Release
    carrierReleaseDate: string | null = null;
    fromCarrierReleaseDate: string | null = null;
    toCarrierReleaseDate: string | null = null;

    //Customs Release
    customsReleaseDate: string | null = null;
    fromCustomsReleaseDate: string | null = null;
    toCustomsReleaseDate: string | null = null;

    //Rail Departure
    railDepartureDate: string | null = null;
    fromRailDepartureDate: string | null = null;
    toRailDepartureDate: string | null = null;

    //Inland ETA
    inlandEta: string | null = null;
    fromInlandEta: string | null = null;
    toInlandEta: string | null = null;

    //Rail Arrival
    railArrivalDate: string | null = null;
    fromRailArrivalDate: string | null = null;
    toRailArrivalDate: string | null = null;

    //Last Free Day
    lastFreeDay: string | null = null;
    fromLastFreeDay: string | null = null;
    toLastFreeDay: string | null = null;

    //Pickup Avilable
    pickupAvailableDate: string | null = null;
    fromPickupAvailableDate: string | null = null;
    toPickupAvailableDate: string | null = null;

    //Pickup Container
    pickupContainerDate: string | null = null;
    fromPickupContainerDate: string | null = null;
    toPickupContainerDate: string | null = null;

    //Actual Delivery
    actualDeliveryDate: string | null = null;
    fromActualDeliveryDate: string | null = null;
    toActualDeliveryDate: string | null = null;

    //Emtpy Return
    emptyReturnDate: string | null = null;
    fromEmptyReturnDate: string | null = null;
    toEmptyReturnDate: string | null = null;

    trId: number|null = null;
    trType: string = '';
    trStatus: string = '';
    trStatusDesc: string = '';

    trDate: string | null = null;
    fromTrDate: string | null = null;
    toTrDate: string | null = null;
    
    //Track Event
    lastEvent: string = '';
    lastEventDate: string | null = null;

    u1Date: string| null = null;
    fromU1Date: string | null = null;
    toU1Date: string | null = null;
    u1ID: string = '';

    broker: string = '';
    amsNo: string = '';
    isfNo: string = '';

    prepBy: string = '';
   
    containerId: number = 0; // container id 정보는 containerId를 사용

    private static ExportCollection: XCol.XExportColumn[] = [
        XCol.Create({ col: 0,  text: '', width: 30, dataIndex: 'status', hiddenInColumnSetup: true }),
        XCol.Create({ col: 1,  text: 'Customer', width: 140, dataIndex: 'customer', defaultColumnFocus: true }),
        XCol.Create({ col: 2,  text: 'Customer Ref. #', width: 100, dataIndex: 'custRefNo' }),
        XCol.Create({ col: 3,  text: 'PO #', width: 80, dataIndex: 'poNo' }),
        XCol.Create({ col: 4,  text: 'RQ Date', width: 90, dataIndex: 'trDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center  }),
        XCol.Create({ col: 5,  text: 'Container Tracking', width: 210, dataIndex: 'trStatus' }),
        XCol.Create({ col: 6,  text: 'MBL #', width: 100, dataIndex: 'mblNo' }),
        XCol.Create({ col: 7,  text: 'HBL #', width: 100, dataIndex: 'hblNo' }),
        XCol.Create({ col: 8, text: 'Container #', width: 100, dataIndex: 'containerNo' }),
        XCol.Create({ col: 9, text: 'Commodity', width: 100, dataIndex: 'commodity' }),
        XCol.Create({ col: 10,  text: 'Type', width: 60, dataIndex: 'conType'}),
        XCol.Create({ col: 11,  text: 'PKGS', width: 70, dataIndex: 'pkgs',type: XCol.XCellType.Double }),
        XCol.Create({ col: 12,  text: 'CBM', width: 70, dataIndex: 'cbm', type: XCol.XCellType.Double }),
        XCol.Create({ col: 13,  text: 'KGS', width: 70, dataIndex: 'kgs', type: XCol.XCellType.Double }),
        XCol.Create({ col: 14,  text: 'LBS', width: 70, dataIndex: 'lbs', type: XCol.XCellType.Double }),
        XCol.Create({ col: 15, text: 'ETD', width: 75, dataIndex: 'etd', type: XCol.XCellType.Date, align: XCol.XAlignType.Center }),
        XCol.Create({ col: 16,  text: 'ETA', width: 75, dataIndex: 'eta', type: XCol.XCellType.Date, align: XCol.XAlignType.Center }),
        XCol.Create({ col: 17, text: 'Container Dispatched', width: 115, dataIndex: 'ord', type: XCol.XCellType.Date, align: XCol.XAlignType.Center }),
        XCol.Create({ col: 18, text: 'Gate In', width: 100, dataIndex: 'inGateDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center }),
        XCol.Create({ col: 19, text: 'Load on Vessel', width: 100, dataIndex: 'loadedDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center }),
        XCol.Create({ col: 20, text: 'Vessel Departure', width: 100, dataIndex: 'vesselDepartureDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center }),
        XCol.Create({ col: 21, text: 'Vessel Arrival', width: 100, dataIndex: 'vesselArrivalDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center }),
        XCol.Create({ col: 22, text: 'Unloaded Vessel', width: 100, dataIndex: 'unloadedDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center }),
        XCol.Create({ col: 23, text: 'Carrier Release', width: 100, dataIndex: 'carrierReleaseDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center }),
        XCol.Create({ col: 24, text: 'Customs Release', width: 100, dataIndex: 'customsReleaseDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center }),
        XCol.Create({ col: 25, text: 'Rail Departure', width: 100, dataIndex: 'railDepartureDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center }),
        XCol.Create({ col: 26, text: 'Inland ETA', width: 100, dataIndex: 'inlandEta', type: XCol.XCellType.Date, align: XCol.XAlignType.Center }),
        XCol.Create({ col: 27, text: 'Rail Arrival', width: 100, dataIndex: 'railArrivalDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center }),
        XCol.Create({ col: 28, text: 'LFD', width: 100, dataIndex: 'lastFreeDay', type: XCol.XCellType.Date, align: XCol.XAlignType.Center }),
        XCol.Create({ col: 29, text: 'Pickup Available', width: 100, dataIndex: 'pickupAvailableDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center }),
        XCol.Create({ col: 30, text: 'Pickup Container', width: 100, dataIndex: 'pickupContainerDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center }),
        XCol.Create({ col: 31, text: 'Actual Delivery', width: 100, dataIndex: 'actualDeliveryDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center }),
        XCol.Create({ col: 32, text: 'Empty CNTR Return', width: 115, dataIndex: 'emptyReturnDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center }),
        XCol.Create({ col: 33, text: 'AMS', width: 120, dataIndex: 'amsNo'}),
        XCol.Create({ col: 34, text: 'ISF', width: 120, dataIndex: 'isfNo'}),
        XCol.Create({ col: 35, text: 'Carrier', width: 120, dataIndex: 'steamShipName'}),
        XCol.Create({ col: 36, text: 'Vessel', width: 120, dataIndex: 'vessel'}),
        XCol.Create({ col: 37, text: 'Voyage', width: 60, dataIndex: 'voyage' }),
        XCol.Create({ col: 38, text: 'Broker', width: 100, dataIndex: 'broker' }),
        XCol.Create({ col: 39,  text: 'Loading Port', width: 100, dataIndex: 'loadingPort' }),
        XCol.Create({ col: 40,  text: 'Discharge Port', width: 100, dataIndex: 'dischargePort' }),
        XCol.Create({ col: 41,  text: 'Place of Delivery', width: 100, dataIndex: 'placeOfDelivery' }),
        XCol.Create({ col: 42,  text: 'F.ETA', width: 75, dataIndex: 'feta', type: XCol.XCellType.Date, align: XCol.XAlignType.Center }),
        XCol.Create({ col: 43,  text: 'Prep. By', width: 60, dataIndex: 'prepBy' }),
        XCol.Create({ col: 44, text: 'Create Date', width: 100, dataIndex: 'u1Date', type: XCol.XCellType.Date, align: XCol.XAlignType.Center }),
        XCol.Create({ col: 45, text: 'Create By', width: 100, dataIndex: 'u1ID', align: XCol.XAlignType.Center }),
    ];


    public static getExportCollection(): XCol.XExportColumn[] {
        return this.ExportCollection;
    };

    public static OrderBy = { orderBy: CustomerShipmentListItem.prototype.eta, orderByAscending: false };

    public static formatData(data: CustomerShipmentListItem[]) {
        return data.map((d: CustomerShipmentListItem, i) => ({
            ...d,
            id: i+1,  //only ui
        }));
    }

    public static MapSearchFields: { [key: string]: { [key: string]: string } } = {
        pkgs: {from : 'fromPkgs', to: 'toPkgs'},
        lbs: {from: 'fromLbs', to: 'toLbs'},
        cbm: {from: 'fromCbm', to: 'toCbm'},
        kgs: {from: 'fromKgs', to: 'toKgs'},
        eta: { from: 'fromEta', to: 'toEta' },
        etd: { from: 'fromEtd', to: 'toEtd' },
        feta: { from: 'fromFeta', to: 'toFeta' },
        ord: { from: 'fromOrd', to: 'toOrd' },
        inGateDate: { from: 'fromInGateDate', to: 'toInGateDate' },
        loadedDate: { from: 'fromLoadedDate', to: 'toLoadedDate' },
        vesselDepartureDate: { from: 'fromVesselDepartureDate', to: 'toVesselDepartureDate' },
        vesselArrivalDate: { from: 'fromVesselArrivalDate', to: 'toVesselArrivalDate' },
        unloadedDate: { from: 'fromUnloadedDate', to: 'toUnloadedDate' },
        carrierReleaseDate: { from: 'fromCarrierReleaseDate', to: 'toCarrierReleaseDate' },
        customsReleaseDate: { from: 'fromCustomsReleaseDate', to: 'toCustomsReleaseDate' },
        railDepartureDate: { from: 'fromRailDepartureDate', to: 'toRailDepartureDate' },
        inlandEta: { from: 'fromInlandEta', to: 'toInlandEta' },
        railArrivalDate: { from: 'fromRailArrivalDate', to: 'toRailArrivalDate' },
        lastFreeDay: { from: 'fromLastFreeDay', to: 'toLastFreeDay' },
        pickupAvailableDate: { from: 'fromPickupAvailableDate', to: 'toPickupAvailableDate' },
        pickupContainerDate: { from: 'fromPickupContainerDate', to: 'toPickupContainerDate' },
        actualDeliveryDate: { from: 'fromActualDeliveryDate', to: 'toActualDeliveryDate' },
        emptyReturnDate: { from: 'fromEmptyReturnDate', to: 'toEmptyReturnDate' },
        trDate: { from: 'fromTrDate', to: 'toTrDate' },
        u1Date: {from : 'fromU1Date', to: 'toU1Date' }
    };
}
